module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_7.88fa6af0.png";